var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"store-panel-header"},[_c('div',{staticClass:"store-panel-header__icon"},[_c('img',{attrs:{"src":require("assets/logo-store.svg"),"alt":"Legalscape Store","width":"194","height":"20"}})])])
}]

export { render, staticRenderFns }